const ourValuesSlider = {
  init: () => {
  if (window.innerWidth < 768) {
    
    $(document).ready(function() {
    var $slider = $('.lsg-our-values__slides');
    var $progressBar = $('.lsg-our-values__progress');
    var $progressBarLabel = $('.lsg-our-values__progress-label');

    $slider.on('init reInit afterChange', function(event, slick) {
      var currentSlide = slick.slickCurrentSlide() + 1;
    
      var initialPercentage = (currentSlide / slick.slideCount) * 100;

      var calc = initialPercentage + ((currentSlide - 1 || 0) / slick.slideCount) * (100 - initialPercentage);
      calc = calc.toFixed(2);

      var backgroundSize = (window.innerWidth > 1023) ? '100% ' + calc + '%' : calc + '% 100%';
    
      $progressBar
        .css('background-size', backgroundSize)
        .attr('aria-valuenow', calc);
    
      $progressBarLabel.text(calc + '% completed');
    });

    $slider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      vertical: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical: false,
          }
        }
      ]
    });
  });
}
}
}

export default ourValuesSlider;
